// components/Reports/FeedsSection.tsx
import {
    Box,
    Heading,
    Spinner,
    Center,
    Text,
    HStack,
  } from "@chakra-ui/react"
import { useQuery } from "@tanstack/react-query"
import { useState } from "react"
import { ReportsService } from "@/client"
import { FaRss } from "react-icons/fa"
import FeedDetail from "@/components/Reports/FeedDetail"
import FeedCard from "@/components/Reports/FeedCard"
import AddFeed from "@/components/Reports/AddFeed"

const FeedsSection = () => {
    const { data, isLoading } = useQuery({
        queryKey: ["feedMetadata"],
        queryFn: () => ReportsService.readFeedMetadata(),
    })

    const [selectedFeedId, setSelectedFeedId] = useState<string | null>(null)
    const [isDialogOpen, setDialogOpen] = useState(false)

    const handleFeedClick = (feedId: string) => {
        setSelectedFeedId(feedId)
        setDialogOpen(true)
    }

    return (
        <Box>
            <Heading size="lg">
                <HStack alignItems="baseline">
                    <Box>RSS 피드 관리</Box>
                    <FaRss/>
                    <AddFeed/>
                </HStack>
            </Heading>
            
            <Box p={4} mb={6} borderRadius="md" borderWidth="1px" overflowY="auto" height="265px">
                {isLoading ? (
                    <Center py={10} flexDirection="column">
                        <Spinner size="lg" color="blue.500" mb={2} />
                        <Text fontSize="sm" color="gray.600">
                            로딩중...
                        </Text>
                    </Center>
                ) : (
                    <FeedCard feeds={data?.data ?? []} onClick={handleFeedClick} />
                )}
            </Box>

            <FeedDetail
                feedId={selectedFeedId}
                isOpen={isDialogOpen}
                onClose={() => {
                    setDialogOpen(false)
                    setTimeout(() => {
                        setSelectedFeedId(null)
                    }, 300)
                }}
            />
        </Box>
    )
}

export default FeedsSection